import {plural} from '../../common/components/Plural.js'
import ListItemsCount from '../../common/components/List/ListItemsCount.js'
import {
  stocktakeListQuerySelector,
  countSelector,
} from './stocktakeListFunctions.js'
import {useSelector} from '../../store.js'

export default function StocktakeListItemsCount() {
  const params = useSelector(stocktakeListQuerySelector)
  const count = useSelector(countSelector)

  return (
    <li className="inline-block margin-right-3">
      <ListItemsCount
        limit={params.limit}
        offset={params.offset}
        count={count}
        thing={plural(count)`Stocktake${['s']}`}
      />
    </li>
  )
}
